import React from "react";
import { useParams } from "react-router";

import config from "../../../config/config";

import "./AnalyticalMethods.scss";

const ESRDAnalyticalMethods2020 = () => {
  const { year } = useParams();

  const download = (refNum) => {
    const url = `${config.baseUri}/analyticalMethods?year=${year}&fileName=${refNum}&volumeNumber=2`;
    window.location = url;
  };

  return (
    <div>
      <h1>Analytical Methods</h1>
      <ul>
        <li>
          <button
            onClick={() =>
              download("Final Data Sources and Methods for ESRD Volume")
            }
          >
            Data Sources and Methods for ESRD Volume
          </button>
        </li>
        <li>
          <button
            onClick={() =>
              download("Codes for Cause of Hospitalization – ESRD Volume")
            }
          >
            Codes for Cause of Hospitalization – ESRD Volume
          </button>
        </li>
        <li>
          <button onClick={() => download("Cause of Death – ESRD Volume")}>
            Cause of Death – ESRD Volume
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ESRDAnalyticalMethods2020;
